import {maltClassicCreationSteps} from '@/profile-creation-wizard/config/steps/MaltClassicCreationSteps';
import {CreationStepName, ProfileCreationFunnelMode, RoutesConfig} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import ProfileCreationRouterHelper from '@/profile-creation-wizard/router/ProfileCreationRouterHelper';

const maltClassicRoutesConfig: RoutesConfig = {
    routes: maltClassicCreationSteps.map((step) => ProfileCreationRouterHelper.buildRouteFromStep(step, ProfileCreationFunnelMode.FREELANCER)),
    creationFirstStep: CreationStepName.SIGNUP_HEADLINE,
    completionFirstStep: CreationStepName.COMPLETION_LINKEDIN,
};

export default maltClassicRoutesConfig;
